import * as React from 'react';
import { Divider, IconButton, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Tooltip, Typography, } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useTranslate } from 'ra-core';
import { ApiStatus } from '../../apis/ApiStatus';
import { useListArrayInputItem } from '../../ui';
export function ApiGroupChoiceItem(props) {
    const { record, selected, onAdd } = useListArrayInputItem();
    const classes = useStyles(props);
    const translate = useTranslate();
    return (React.createElement(ExpansionPanel, null,
        React.createElement(ExpansionPanelSummary, { expandIcon: React.createElement(ExpandMoreIcon, null) },
            React.createElement(Tooltip, { title: translate('ra.action.add') },
                React.createElement("span", null,
                    React.createElement(IconButton, { "aria-label": translate('ra.action.add'), className: classes.add, disabled: selected, onClick: onAdd, color: "primary" },
                        React.createElement(AddIcon, null)))),
            React.createElement("div", { className: classes.root },
                React.createElement(Typography, null, record.name),
                React.createElement(Typography, { className: classes.apiCount },
                    "(",
                    record.apis.length,
                    ")"),
                React.createElement(Typography, { className: classes.status }, translate(`resources.apis.portalStatus.${record.status.toLowerCase()}`)))),
        React.createElement(ExpansionPanelDetails, null,
            React.createElement("div", { className: classes.details },
                React.createElement(Typography, { className: classes.description }, record.description),
                React.createElement(Divider, null),
                React.createElement("div", { className: classes.list }, record.apis.map(api => (React.createElement("div", { className: classes.api, key: api.uuid },
                    React.createElement("div", null, api.name),
                    React.createElement(ApiStatus, { record: api, variant: "caption" })))))))));
}
const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
    },
    add: {
        marginTop: theme.spacing(-1),
    },
    apiCount: {
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing(1),
    },
    details: {
        marginTop: theme.spacing(-2),
        marginLeft: theme.spacing(6),
        width: '100%',
    },
    status: {
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing(2),
        fontSize: '0.8rem',
        textTransform: 'lowercase',
    },
    description: {
        marginTop: theme.spacing(0),
        fontSize: theme.typography.pxToRem(14),
    },
    list: {
        marginTop: theme.spacing(1),
        width: '100%',
    },
    api: {
        display: 'flex',
        justifyContent: 'space-between',
        textAlign: 'left',
        marginTop: theme.spacing(1),
    },
}), {
    name: 'Layer7ApiGroupChoiceItem',
});
//# sourceMappingURL=ApiGroupChoiceItem.js.map